import { X } from '@phosphor-icons/react';
import { useScreenView } from '../../../../../../../utils/ScreenViewContext';
import { AccentButton } from '../../../../../../../shared/Buttons';

/**
 * Post-payment confirmation screen, shown after a manual cash-advance payment is
 * submitted. Mirrors WithdrawalSuccess: a persistent notice (rather than a transient
 * toast) so the "advance balance can take up to an hour" caveat isn't missed.
 */
export const PayTowardAdvanceSuccess = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const { screenView } = useScreenView();

  const renderScreenView = (screenView: string) => {
    switch (screenView) {
      case 'desktop':
      case 'tablet':
      case 'mobile':
        return (
          <div className="fixed inset-0 z-[999] flex items-center justify-center bg-gray-900 bg-opacity-50">
            <div className="h-auto max-h-[90%] w-full overflow-x-hidden rounded-[4px] bg-white sm:max-w-[90%] md:max-w-[60%] lg:max-w-[600px]">
              <div className="flex h-[56px] w-full flex-row items-center justify-between p-4 align-middle">
                <h2 className="text-[16px] font-[600] text-primary">
                  Payment successfully submitted
                </h2>
                <X
                  className="hover:cursor-pointer hover:opacity-80"
                  onClick={onClose}
                  weight="regular"
                  size={24}
                />
              </div>

              <div className="flex h-full w-full flex-col items-center gap-6 overflow-y-auto overflow-x-hidden border-[1px] border-bordergray p-6">
                <div className="flex w-full flex-row items-center space-x-4 align-middle">
                  <p>
                    Your advance&apos;s remaining balance can take up to an hour
                    to reflect the payment.
                  </p>
                </div>
              </div>

              <div className="flex justify-end space-x-2 p-4">
                <AccentButton
                  onClick={onClose}
                  addClass="rounded-full hover:bg-yellow-600 w-[238px] h-[48px] flex flex-row items-center justify-center"
                >
                  I understand
                </AccentButton>
              </div>
            </div>
          </div>
        );
    }
  };

  return <>{renderScreenView(screenView)}</>;
};

export default PayTowardAdvanceSuccess;
